import { render } from "./UGCFilters.vue?vue&type=template&id=040cbfc1&scoped=true"
import script from "./UGCFilters.vue?vue&type=script&lang=js"
export * from "./UGCFilters.vue?vue&type=script&lang=js"

import "./UGCFilters.vue?vue&type=style&index=0&id=040cbfc1&scoped=true&lang=css"

import exportComponent from "/var/www/ab-front-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-040cbfc1"]])

export default __exports__